module.exports = __webpack_public_path__ + "img/ceramic.cf832d5.jpg";